import { render, staticRenderFns } from "./agentScoreShenpi.vue?vue&type=template&id=edd588e4"
import script from "./agentScoreShenpi.vue?vue&type=script&lang=js"
export * from "./agentScoreShenpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports